import { RateReview } from '@mui/icons-material';
import { ToggleButton, Tooltip } from '@mui/material';
import { LineChart } from 'lucide-react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { currentStructureSetState } from '~/state/atoms/structureSet/structureSetAtoms';
import { reviewToolState } from '~/state/atoms/toolsAtoms';
import {
    showDoseStatisticsTableState,
    showDVHViewComponentState,
} from '~/state/atoms/viewerAtoms';

export const ReviewStructuresToggle = () => {
    const [reviewStructuresOpen, setReviewStructuresOpen] =
        useRecoilState(reviewToolState);
    const selectedStructureSet = useRecoilValue(currentStructureSetState);
    const isDisabled =
        !selectedStructureSet || selectedStructureSet.roiArray.length === 0;
    return (
        <ToggleButton
            value="review-structures"
            selected={reviewStructuresOpen}
            onChange={() => setReviewStructuresOpen((state) => !state)}
            disabled={isDisabled}
            aria-disabled={isDisabled}
            data-testid="review-structures-toggle"
        >
            <Tooltip title="Review structures">
                <RateReview />
            </Tooltip>
        </ToggleButton>
    );
};

export const DVHLayoutToggle = () => {
    const [showDVHViewComponent, setShowDVHViewComponent] = useRecoilState(
        showDVHViewComponentState
    );
    const [showDoseStatisticsTable, setShowDoseStatisticsTable] =
        useRecoilState(showDoseStatisticsTableState);
    return (
        <ToggleButton
            value="dvh-view"
            selected={showDVHViewComponent || showDoseStatisticsTable || false}
            onChange={() => {
                setShowDVHViewComponent(!showDVHViewComponent);
                setShowDoseStatisticsTable(!showDoseStatisticsTable);
            }}
            disabled={
                showDVHViewComponent === null &&
                showDoseStatisticsTable === null
            }
            data-testid="dvh-view-toggle"
        >
            <Tooltip title="Dose-volume histogram">
                <LineChart />
            </Tooltip>
        </ToggleButton>
    );
};
